<template>
	<div>
		<BaseSelect
			ref="BaseInput.opponentSelection"
			:required="false"
			:label="$t('opponent')"
			:options="options"
			v-model="selectedOpponentOption"
			:allow-empty="false"
			@input="changeOpponentType"
		/>

		<div v-if="showPerson" class="flex flex-wrap w-full">
			<BaseInput
				ref="BaseInput.oppositePersonFirstName"
				v-model="oppositeParty.oppositePerson.firstName"
				:required="false"
				class="w-full md:w-1/2 pr-0 md:pr-2"
				:label="$t('first_name')"
				type="text"
				@input="updateValue"
			/>

			<BaseInput
				ref="BaseInput.oppositePersonLastName"
				v-model="oppositeParty.oppositePerson.lastName"
				:required="false"
				class="w-full md:w-1/2"
				:label="$t('last_name')"
				type="text"
				@input="updateValue"
			/>
		</div>

		<div v-else class="w-full">
			<LicensePlateInput
				ref="LicensePlateInput"
				v-model="oppositeParty.oppositeLicensePlate"
				:display="true"
				:required="false"
				@input="updateValue"
			/>
		</div>

		<div class="flex flex-wrap mt-4">
			<BaseInput
				v-model="oppositeParty.insuranceName"
				:required="false"
				class="w-full"
				:label="$t('opposite_insurance_name')"
				type="text"
				@input="updateValue"
			/>
		</div>
		<div class="flex flex-wrap mt-4">
			<BaseInput
				v-model="oppositeParty.insuranceNumber"
				:required="false"
				class="w-full md:w-1/2 pr-0 md:pr-2"
				:label="$t('opposite_insurance_number')"
				type="text"
				@input="updateValue"
			/>
			<BaseInput
				v-model="oppositeParty.insuranceCaseNumber"
				:required="false"
				class="w-full md:w-1/2"
				:label="$t('opposite_insurance_case_number')"
				type="text"
				@input="updateValue"
			/>
		</div>
	</div>
</template>

<script>
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import BaseInput from '@/components/forms/inputs/BaseInput';
import LicensePlateInput from '@/components/forms/inputs/LicensePlateInput';

export default {
	name: 'DamageAssessorCaseOppositePersonForm',

	components: {
		BaseSelect,
		BaseInput,
		LicensePlateInput,
	},

	props: {
		value: {
			type: Object,
			default: () => ({}),
		},
	},

	data() {
		return {
			showPerson: false,

			options: [
				{
					display: this.$t('save_opponent_as_license_plate'),
					value: 'licensePlate',
				},
				{
					display: this.$t('save_opponent_as_person'),
					value: 'person',
				},
			],

			selectedOpponentOption: null,

			oppositeParty: this.createStartValue(),
		};
	},

	computed: {
		hasOppositePerson() {
			const person = this.value?.oppositePerson;

			if (!person) {
				return false;
			}

			return !!(person.firstName || person.lastName);
		},
	},

	mounted() {
		const hasLicensePlate = !!this.value?.oppositeLicensePlate?.text;
		const hasPerson = !!(this.value?.oppositePerson?.firstName || this.value?.oppositePerson?.lastName);

		if (hasLicensePlate) {
			this.showPerson = false;
			this.selectedOpponentOption = this.options[0];
		} else if (hasPerson) {
			this.showPerson = true;
			this.selectedOpponentOption = this.options[1];
		} else {
			this.showPerson = false;
			this.selectedOpponentOption = this.options[0];
		}
	},

	methods: {
		createStartValue() {
			return {
				oppositePerson: {
					firstName: this.value?.oppositePerson?.firstName ?? null,

					lastName: this.value?.oppositePerson?.lastName ?? null,
				},

				oppositeLicensePlate: {
					text: this.value?.oppositeLicensePlate?.text ?? null,

					isSpecial: this.value?.oppositeLicensePlate?.isSpecial ?? false,
				},

				insuranceName: this.value?.insuranceName ?? null,

				insuranceNumber: this.value?.insuranceNumber ?? null,
				insuranceCaseNumber: this.value?.insuranceCaseNumber ?? null,
			};
		},

		createEmptyPerson() {
			return {
				firstName: null,
				lastName: null,
			};
		},

		changeOpponentType(option) {
			this.selectedOpponentOption = option;
			this.showPerson = option?.value === 'person';
		},

		updateValue() {
			const value = {
				oppositePerson: {
					firstName: this.oppositeParty?.oppositePerson?.firstName ?? null,

					lastName: this.oppositeParty?.oppositePerson?.lastName ?? null,
				},

				oppositeLicensePlate: {
					text: this.oppositeParty?.oppositeLicensePlate?.text ?? null,

					isSpecial: this.oppositeParty?.oppositeLicensePlate?.isSpecial ?? false,
				},

				insuranceName: this.oppositeParty?.insuranceName ?? null,

				insuranceNumber: this.oppositeParty?.insuranceNumber ?? null,
				insuranceCaseNumber: this.oppositeParty?.insuranceCaseNumber ?? null,
			};

			this.$emit('input', value);
			this.$emit('updateValue', value);
		},

		validate() {
			if (!this.showPerson && this.$refs.LicensePlateInput?.validate) {
				return this.$refs.LicensePlateInput.validate();
			}

			return true;
		},
	},
};
</script>

<style scoped></style>
